import React, { PropsWithChildren } from 'react';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonProps } from '@mui/material';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ColorPalette } from '../../config';
import { NavigationGuid } from '../main-navigation/main-navigation-items';

export interface IAreaToolbarButtonProps extends PropsWithChildren<Record<string, unknown>> {
  icon: IconProp;
  onClick?: ButtonProps['onClick'];
  showOn?: NavigationGuid;
  hidden?: boolean;
  disabled?: boolean;
}

const useStyles = makeStyles<IAreaToolbarButtonProps>()((theme: Theme, params) => ({
  toolbarButtonRoot: {
    display: params.hidden ? 'none' : '',
    textTransform: 'none',
    color: ColorPalette.CityNightSkies,
    padding: theme.spacing(0, 1, 0, 2),
  },
  toolbarButtonIcon: {
    '& > *:first-child': {
      fontSize: 14,
    },
  },
}));

export function AreaToolbarButton(props: IAreaToolbarButtonProps) {
  const { icon, children, onClick, disabled } = props;
  const { classes } = useStyles(props);

  return (
    <Button
      disabled={disabled}
      variant="text"
      startIcon={<FontAwesomeIcon icon={icon} />}
      classes={{ root: classes.toolbarButtonRoot, iconSizeMedium: classes.toolbarButtonIcon }}
      onClick={onClick}
    >
      {children}
    </Button>
  );
}
